import LicenseList from "./components/LicenseList.vue";
import ExecutiveDashboard from "./components/ExecutiveDashboard.vue";
import virtualView from "@/router/virtualView";

export default {
  path: "license",
  component: virtualView,
  children: [
    {
      path: "",
      name: "License Review",
      redirect: "application/list",
    },
    {
      path: "list/:stage?",
      name: "License List",
      component: LicenseList,
    },
    {
      path: "reports",
      name: "Executive Dashboard",
      component: ExecutiveDashboard,
    },
  ],
};
